import { domains } from './domains.ts'

const regex =
  /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export function validateEmail(email: string) {
  if (!email) return false
  const emailParts = email.split('@')
  if (emailParts.length !== 2) return false

  const [account, domain] = emailParts
  if (account.length > 64) return false
  else if (domain.length > 255) return false
  if (domains.includes(domain)) return false

  const domainParts = domain.split('.')
  if (
    domainParts.some((part) => {
      return part.length > 63
    })
  )
    return false

  return regex.test(email)
}
